import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=b1f7037e&"
import script from "./Like.vue?vue&type=script&lang=js&"
export * from "./Like.vue?vue&type=script&lang=js&"
import style0 from "./Like.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f7037e')) {
      api.createRecord('b1f7037e', component.options)
    } else {
      api.reload('b1f7037e', component.options)
    }
    module.hot.accept("./Like.vue?vue&type=template&id=b1f7037e&", function () {
      api.rerender('b1f7037e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/Like.vue"
export default component.exports